document.addEventListener('DOMContentLoaded', () => {
  const sections = document.querySelectorAll('[data-counter-section]');
  if (!sections.length) return;

  const easeOut = (t) => 1 - Math.pow(1 - t, 3);

  const animateCount = (el) => {
    if (el.dataset.counted === 'true') return;
    el.dataset.counted = 'true';

    const target = parseFloat(el.dataset.target || '0');
    const duration = 1200;
    const start = performance.now();

    const tick = (now) => {
      const progress = Math.min((now - start) / duration, 1);
      const value = Math.floor(easeOut(progress) * target);
      const valueNode = el.querySelector('[data-counter-value]');
      if (valueNode) valueNode.textContent = value.toLocaleString();
      else el.textContent = value.toLocaleString();
      if (progress < 1) requestAnimationFrame(tick);
      else if (valueNode) valueNode.textContent = target.toLocaleString();
      else el.textContent = target.toLocaleString();
    };

    requestAnimationFrame(tick);
  };

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.querySelectorAll('[data-counter-target]').forEach(animateCount);
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.3 }
  );

  sections.forEach((section) => observer.observe(section));
});
